export const TabShapes = {
  OUTLINED: 'OUTLINED',
  FLAT: 'FLAT',
  FILLED: 'FILLED',
  FILTER: 'FILTER',
  VIEW_SWITCHER: 'VIEW_SWITCHER'
};
